import React from 'react';
import './sangaprofile.css';

function SangaProfile() {
  const monks = [
    {
      image: "sangaprofile2.jpg",
        
      name: "Most Venerable Hipankande Sadhasiri Anunayaka Thero",
      titles: [
        "Anuunayaka Thero of Amarapura SiriSaddhamma Wangsa Maha Nikaya",
        "Founder of Vidya Samadhi National Sanga Council",
        "Janahithakari Wishwakeerthi Sri Shasana Shobhana Dammadassi Sadhdhasoma Vangshalankara",
        "Venerable Advisor of The Ehipassiko Buddhist Center"
      ],
   
       
      

      // education: [
      //   "Advanced degrees from multiple Sri Lankan universities",
      //   "Advanced meditation training at Na Uyana Forest Monastery"
      // ]
    },
    
    {
      image: "sangaprofile1.jpg",
      name: "Most Venerable Ambilipitiye Rahula Nayaka Thero",
      titles: [
        "Council Member of Amarapura SiriSadhdhamma Wangsa Mahanikaya",
        "Chief Adhikarana Sangha Nayaka of Galle District",
        "Chairman of Vidya Sanadhi National Sanga Council",
        "Director of Galle Vidya Sanadhi Maha Pirivena Network",
        "Venerable Advisor of Ehepassiko Buddhist Centre"
      ],

    },
   
    {
      image: "sangaprofile3.png",
      name: "Venerable Korathota Dhammadassi Thero",
      roles: [
        "Chief Incumbent of Melbourne Mernda Ehipassiko Buddhist Centre",
        "International Affairs Secretary of Vidya Samadhi National Sanga Council"
      ]
    }
  ];

  return (
    <div className="sangha-container">
      {/* Header */}
      <header className="sangha-header">
        <div className="header-decoration"></div>
        <h1>Our Venerable Sangha</h1>
        <div className="header-decoration"></div>
      </header>

      <p className="sangha-introduction">
        We honor the noble bhikkhus who guide our spiritual path with wisdom and compassion.
      </p>

      {/* Monk Profiles */}
      <div className="monk-profiles-container">
        {monks.map((monk, index) => (
          <article key={index} className="monk-profile">
            <div className="monk-portrait-container">
              <img 
                src={monk.image} 
                alt={monk.name}
                className="monk-portrait"
              />
              <div className="portrait-border"></div>
            </div>

            <div className="monk-details">
              <h2 className="monk-name">{monk.name}</h2>
              
              {/* Titles Section */}
              {monk.titles && (
                <section className="detail-section">
                  <h3 className="section-title"></h3>
                  <ul className="detail-list">
                    {monk.titles.map((title, i) => (
                      <li key={i} className="detail-item">
                        <div className="detail-marker"></div>
                        <p>{title}</p>
                      </li>
                    ))}
                  </ul>
                </section>
              )}

              {/* Honors Section */}
              {monk.honors && (
                <section className="detail-section">
                  <h3 className="section-title">Honors</h3>
                  <div className="honors-container">
                    {monk.honors.map((honor, i) => (
                      <div key={i} className="honor-item">
                        {honor}
                      </div>
                    ))}
                  </div>
                </section>
              )}

              {/* Education Section */}
              {monk.education && (
                <section className="detail-section">
                  <h3 className="section-title">Education</h3>
                  <ul className="detail-list">
                    {monk.education.map((item, i) => (
                      <li key={i} className="detail-item">
                        <div className="detail-marker"></div>
                        <p>{item}</p>
                      </li>
                    ))}
                  </ul>
                </section>
              )}

              {/* Roles Section */}
              {monk.roles && (
                <section className="detail-section">
                  <h3 className="section-title">Current Roles</h3>
                  <ul className="detail-list">
                    {monk.roles.map((role, i) => (
                      <li key={i} className="detail-item">
                        <div className="detail-marker"></div>
                        <p>{role}</p>
                      </li>
                    ))}
                  </ul>
                </section>
              )}
            </div>
          </article>
        ))}
      </div>

      {/* Footer Blessing */}
      <footer className="sangha-footer">
        <div className="footer-decoration"></div>
        <p className="blessing-text">
          May the noble Sangha continue to illuminate the path of Dhamma for all beings.<br />
          We bow with reverence to these venerable teachers.
        </p>
        <div className="footer-decoration"></div>
      </footer>
    </div>
  );
}

export default SangaProfile;